module.exports = __webpack_public_path__ + "img/2.bc121062.png";